export enum UserRoles {
  MdrtStaff = "MDRT Staff",
  StoreBulkOrders = "Store Bulk Orders",
}